var render = function () {
  var _vm$item, _vm$item2, _vm$item3, _vm$item4, _vm$item5, _vm$item6;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "500"
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    staticClass: "v-card--dialog v-card--dialog--sm"
  }, [_c('div', {
    staticClass: "v-card--dialog__head"
  }, [_c('h3', {
    staticClass: "tit tit--xs"
  }, [_vm._v("주문수정")]), _c('v-btn', {
    staticClass: "v-card--dialog__close",
    attrs: {
      "fab": "",
      "color": "transparent"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('div', {
    staticClass: "v-card--dialog__body"
  }, [_c('v-divider', {
    staticClass: "grey darken-4"
  }), _c('div', {
    staticClass: "px-8px py-12px px-md-10px py-md-16px"
  }, [_c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('div', {
    staticClass: "pr-10px"
  }, [_c('div', {
    staticClass: "border mx-auto"
  }, [_c('v-img', {
    attrs: {
      "src": (_vm$item = _vm.item) === null || _vm$item === void 0 ? void 0 : _vm$item.thumb,
      "width": "120",
      "aspect-ratio": 1 / 1,
      "contain": ""
    }
  })], 1)])]), _c('v-col', [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "font-size-16 font-weight-medium text-truncate"
  }, [_vm._v(_vm._s((_vm$item2 = _vm.item) === null || _vm$item2 === void 0 ? void 0 : _vm$item2.name))])]), ((_vm$item3 = _vm.item) === null || _vm$item3 === void 0 ? void 0 : _vm$item3.type) == 'option' ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "font-size-14 font-size-md-16"
  }, [_vm._v("[" + _vm._s((_vm$item4 = _vm.item) === null || _vm$item4 === void 0 ? void 0 : _vm$item4.optionalNames.toString()) + "] : " + _vm._s((_vm$item5 = _vm.item) === null || _vm$item5 === void 0 ? void 0 : _vm$item5.optionalValues.toString()))])]) : _vm._e(), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "d-inline-flex align-center font-size-18 font-size-md-24"
  }, [_c('b', {
    staticClass: "primary--text"
  }, [_vm._v(_vm._s(parseInt((_vm$item6 = _vm.item) === null || _vm$item6 === void 0 ? void 0 : _vm$item6.salePrice).format()))]), _c('span', {
    staticClass: "font-size-16 ml-2px"
  }, [_vm._v("원")])])])], 1)], 1)], 1)], 1)], 1)], 1), _c('v-divider'), _c('div', {
    staticClass: "px-8px py-12px px-md-10px py-md-16px"
  }, [_c('optional-products', {
    attrs: {
      "product": _vm.mainProduct
    },
    on: {
      "edit": function edit(ca) {
        return _vm.a(ca);
      }
    },
    model: {
      value: _vm.cart,
      callback: function callback($$v) {
        _vm.cart = $$v;
      },
      expression: "cart"
    }
  })], 1)], 1), _c('div', {
    staticClass: "v-card--dialog__foot"
  }, [_c('v-row', {
    staticClass: "row--x-small"
  }, [_c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.addToCart
    }
  }, [_vm._v("확인")])], 1)], 1)], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }